<div class="flex flex-col bg-white -m-3" style="width: 300px">
  <div class="p-2 flex flex-col border-gray-300 border-b gap-y-1 w-full">
    <span class="font-bold text-lg text-gray-800">Events on {{ data.date | date: 'longDate' }}</span>
  </div>
  <div class="flex flex-col p-2 bg-gray-200 gap-y-1" *ngIf="data.events && data.events.length > 0">
    <div class="flex flex-col gap-y-2">
      <span *ngFor="let event of data.events; trackBy: 'id' | trackByKey" class="card-with-shadow bg-white p-2">
        <ng-container [ngSwitch]="event.eventType">
          <ng-container *ngSwitchCase="'bonus'">
            <ng-container [ngSwitch]="event.ordersPricingType">
              <ng-container *ngSwitchCase="'flat_rate_cents'">
                <div class="flex-col justify-center col-span-3">
                  <div class="font-bold text-blue-600">
                    {{ event.name }} - Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                  </div>
                  <div class="text-gray-600">
                    {{ event.startsAt | standardDateOnly }} - {{ event.endsAt | standardDateOnly }}
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'percent'">
                <div class="flex-col justify-center col-span-3">
                  <div class="font-bold text-blue-600">
                    {{ event.name }} - Additional Bonus of {{ event.ordersPricingValue * 100 | number }}%
                  </div>
                  <div class="text-gray-600">
                    {{ event.startsAt | standardDateOnly }} - {{ event.endsAt | standardDateOnly }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'deadhead'">
            <ng-container [ngSwitch]="event.ordersPricingType">
              <ng-container *ngSwitchCase="'flat_rate_cents'">
                <div class="flex-col justify-center col-span-3">
                  <div class="font-bold text-blue-600">
                    {{ event.name }} - Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                  </div>
                  <div class="text-gray-600">
                    {{ event.startsAt | standardDateOnly }} - {{ event.endsAt | standardDateOnly }}
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'percent'">
                <div class="flex-col justify-center col-span-3">
                  <div class="font-bold text-blue-600">
                    {{ event.name }} - Additional Bonus of {{ event.ordersPricingValue * 100 }}%
                  </div>
                  <div class="text-gray-600">
                    {{ event.startsAt | standardDateOnly }} - {{ event.endsAt | standardDateOnly }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'driver_retention'">
            <div class="flex-col justify-center col-span-3">
              <div class="font-bold text-blue-600">
                {{ event.name }} - Additional Bonus of {{ event.retentionsPricingValue | currencyInPennies }}
              </div>
              <div class="text-gray-600">
                {{ event.startsAt | standardDateOnly }} - {{ event.endsAt | standardDateOnly }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </span>
    </div>
  </div>
</div>
